<!-- Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and -->
<!-- matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, -->
<!-- including without limitation, material generated from the software programs which are displayed on the screen such -->
<!-- as icons, screen display looks, etc. -->
<section class="standard-redaction-items">
  @if (!isMfd) {
    <section>
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
      </div>
    </section>
  }
  @if (isMfd) {
    <section class="mfd">
      <div class="action-bar">
        <div class="left">
          <button
            type="button"
            class="xrx-btn btn-secondary btn medium glyph xgl-close mfd"
            data-dismiss="modal"
            aria-label="Close"
            (click)="activeModal.dismiss()">
            <span aria-hidden="true" class="xgl-close"></span>
          </button>
        </div>
        <div class="right">
          <button
            class="xrx-btn btn-secondary btn medium glyph xgl-navigate_right"
            type="button"
            (click)="activeModal.close()">
            <span
              class="btn-label text-medium button-forward-label"
              xdaTranslate
              >SDE_OK</span
            >
          </button>
        </div>
        <div class="middle">
          <span class="title text-x-large">{{ title }}</span>
        </div>
      </div>
    </section>
  }

  <!-- Search -->
  <section
    class="modal-body {{ uiLang }}"
    [ngClass]="{ 'web-portal': !isMfd }"
    tabindex="-1">
    <div class="form-group doc-icon-search-input">
      <div class="input-group" [ngClass]="{ 'input-group-lg': isMfd }">
        <input
          type="text"
          class="form-control search-term"
          [ngClass]="{ mfd: isMfd, 'web-portal': !isMfd }"
          #searchInput
          [(ngModel)]="searchTerm"
          placeholder="{{ placeholder }}"
          id="doc-icon-search"
          aria-label="Search"
          autocomplete="off" />
        <i
          class="xgl-search"
          [ngClass]="{ mfd: isMfd, 'web-portal': !isMfd }"></i>
      </div>
    </div>

    @if (!isMfd) {
      <div class="form-group standard-field-group">
        <div>
          @for (
            item of displayList;
            track item;
            let first = $first;
            let last = $last
          ) {
            <div
              class="form-control d-flex"
              [ngClass]="{ mfd: isMfd, 'web-portal': !isMfd }">
              <div class="w-100">
                <xrx-checkbox
                  class="cb"
                  label="{{ item.displayText }}"
                  [(checkBoxValue)]="item.preferred"
                  name="{{ item.displayText }}"></xrx-checkbox>
              </div>
              @if (item.descriptionText) {
                <div class="details">
                  <span
                    ><i
                      class="xgl-details xglsize-24"
                      placement="left"
                      [autoClose]="true"
                      [popoverClass]="
                        first ? 'first-popover xrx-popover' : 'xrx-popover'
                      "
                      [ngbPopover]="item.descriptionText"></i
                  ></span>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (isMfd) {
      <div
        class="form-group standard-field-group scroll-content {{
          scrollClass
        }}">
        <div>
          @for (item of displayList; track item) {
            <div
              class="form-control d-flex"
              [ngClass]="{ mfd: isMfd, 'web-portal': !isMfd }">
              <div class="checkbox-left">
                <xrx-checkbox
                  class="cb"
                  label="{{ item.displayText }}"
                  [(checkBoxValue)]="item.preferred"
                  name="{{ item.displayText }}"></xrx-checkbox>
              </div>
              @if (item.descriptionText) {
                <div class="details-right">
                  <span
                    ><i
                      class="xgl-details xglsize-24"
                      placement="left"
                      [autoClose]="true"
                      [ngbPopover]="item.descriptionText"></i
                  ></span>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </section>

  @if (!isMfd) {
    <section>
      <div class="modal-footer">
        <div class="cb">
          <button
            type="button"
            class="xrx-btn btn-secondary"
            data-dismiss="modal"
            (click)="activeModal.dismiss()">
            <span class="btn-label" xdaTranslate>SDE_CANCEL</span>
          </button>
        </div>
        <div class="cb">
          <button
            type="button"
            class="xrx-btn btn-primary"
            (click)="activeModal.close()">
            <span class="btn-label" xdaTranslate>SDE_OK</span>
          </button>
        </div>
      </div>
    </section>
  }
</section>
